/**
 * Tipos e catálogo de campo dos 4 fornecedores de integração (Sankhya, Senior HCM, Dimep Kairos,
 * Ponto Icarus). Espelha `backend/src/config/integrationProviders.ts` — mudar os campos de um
 * provider exige editar os dois lados (não há endpoint de metadados ainda).
 */

export type IntegrationProvider = 'sankhya' | 'senior_hcm' | 'dimep_kairos' | 'ponto_icarus';

export interface IntegrationCredentialField {
  key: string;
  label: string;
  secret: boolean;
}

export interface IntegrationProviderDefinition {
  provider: IntegrationProvider;
  label: string;
  fields: readonly IntegrationCredentialField[];
}

export const INTEGRATION_PROVIDER_DEFINITIONS: readonly IntegrationProviderDefinition[] = [
  {
    provider: 'sankhya',
    label: 'Sankhya (API Gateway)',
    fields: [
      { key: 'client_id', label: 'Client ID', secret: false },
      { key: 'client_secret', label: 'Client Secret', secret: true },
      { key: 'x_token', label: 'X-Token', secret: true },
    ],
  },
  {
    provider: 'senior_hcm',
    label: 'Senior HCM — Jornada do Colaborador',
    fields: [
      { key: 'client_id', label: 'Client ID', secret: false },
      { key: 'username', label: 'Usuário', secret: false },
      { key: 'password', label: 'Senha', secret: true },
    ],
  },
  {
    provider: 'dimep_kairos',
    label: 'Dimep Kairos',
    fields: [
      { key: 'username', label: 'Usuário', secret: false },
      { key: 'password', label: 'Senha', secret: true },
    ],
  },
  {
    provider: 'ponto_icarus',
    label: 'Ponto Icarus',
    fields: [
      { key: 'username', label: 'Usuário', secret: false },
      { key: 'password', label: 'Senha', secret: true },
    ],
  },
];

/** O que a API devolve: nunca o valor de um campo secreto, só se está preenchido. */
export interface IntegrationCredentialSummary {
  provider: IntegrationProvider;
  label: string;
  active: boolean;
  lastUsedAt: string | null;
  filledFields: Record<string, boolean>;
}

export interface IntegrationCredentialInput {
  label: string;
  fields: Record<string, string>;
}
